import {AxiosResponse, CancelToken} from 'axios';
import {Notification} from '../backend/interfaces/notification';
import {PutNotificationsSubscription} from '../backend/requests/put-notification-subscription';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class NotificationsRepository {
  // Singleton Instance
  private static _instance: NotificationsRepository;

  // Private
  private logger: Logger;

  static get instance(): NotificationsRepository {
    if (!this._instance) {
      this._instance = new NotificationsRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('NotificationsRepository');
  }

  // Get user notifications
  public async get(
    limit: number,
    skip: number,
    cancelToken?: CancelToken
  ): Promise<{totalCount: number; data: Array<Notification<any>>}> {
    // Set url
    let url: string = `/notifications?limit=${limit}&skip=${skip}`;

    // Get notifications from backend
    const result: AxiosResponse<Array<Notification<any>>> = await BackendApiManager.instance.get<
      Array<Notification<any>>
    >(url, {
      cancelToken,
    });

    // Return
    return {data: result.data, totalCount: parseInt(result.headers['x-total-count'] || '', 10)};
  }

  // Update the wasRead property of a notification
  public async updateStatusById(notificationId: string, flag: boolean): Promise<Notification<any>> {
    // Mark notification as read or unread
    const response: AxiosResponse<Notification<any>> = await BackendApiManager.instance.patch<
      Notification<any>
    >(`notifications/${notificationId}/read/${flag}`);

    // return
    return response.data;
  }

  // Update the wasRead property of all notifications
  public async updateStatusAll(flag: boolean): Promise<void> {
    // Mark all notification as read or unread
    await BackendApiManager.instance.patch<void>(`notifications/read/${flag}`);
  }

  // Update notification subscription
  public async updateSubscription(
    deviceCode: string,
    body: PutNotificationsSubscription
  ): Promise<void> {
    // Update notification subscription
    await BackendApiManager.instance.put(`/notifications/subscriptions/${deviceCode}`, body);
  }

  // Remove notification
  public async deleteSubscription(deviceCode: string): Promise<void> {
    // Remove notification subscription
    await BackendApiManager.instance.delete(`/notifications/subscriptions/${deviceCode}`);
  }
}
